module.exports = __webpack_public_path__ + "img/1.08.thmb.xs.5ea77a16.jpg";